import React from "react";
import SizingSummary from "./SizingSummary";
import DropdownButton from "../../common/dropdown-button";
import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import { downloadJLMainReport } from "../../../store/jetlift/JetliftCalculationSlice";

const mainReportOptions = [
    { name: "Acrobat(PDF) file", value: "PDF" },
    { name: "CSV (comma delimited)", value: "CSV" },
    { name: "Rich Text Format", value: "RTF" },
    { name: "TIFF file", value: "IMAGE" },
];

const Reports: React.FC = () => {
    const dispatch = useAppDispatch();

    const downloadMainReport = (reportType: string) => {
        dispatch(downloadJLMainReport({ reportType }));
    };

    return (
        <div className="border-[1px] flex flex-col gap-4 border-darkcolor-400 bg-darkcolor-700 rounded-lg p-4">
            <div className="border-b-[1px] border-darkcolor-400 flex justify-end pb-4">
                <DropdownButton
                    mainButtonLabel="Print"
                    mainButtonlClick={() => downloadMainReport("PDF")}
                    optionClick={downloadMainReport}
                    options={mainReportOptions}
                    className="bg-primary-500"
                />
            </div>
            <SizingSummary />
        </div>
    );
};

export default Reports;
